// extracted by mini-css-extract-plugin
module.exports = {"back":"Preferences_back__1RKgp","extra":"Preferences_extra__3JxgM","button__container":"Preferences_button__container__wngwz","advanced":"Preferences_advanced__2cN1I"};